import { Space } from "antd";
import React, { useEffect, useState } from "react";
import DefaultFormParserLayout from "../../../components/Layouts/default-form-parser-layout";
import Button from "../../../components/UI/Button";
import SelectInput from "../../../components/UI/SelectInput";
import SmartSearch from "../../../components/UI/SmartSearch";
import { useLoading } from "../../../context/LoadingProvider/useLoading";
import { getReport, getStorageUsageVersions} from "../../../services/reports";
import { Output } from "../../../services/types";
import endpoints from "../../../utils/endpoints";
import { removeEmpty } from "../../../utils/objectUtils";
import { ISelectOption } from "../../../components/UI/SelectInput/types";
import {notificationError} from "../../../services/notification";


const rangeOptions = [
    {name: "ALL", value: 0},
    {name: "Less than 50GB", value: 50},
    {name: "50GB - 100GB", value: 100},
    {name: "100GB - 200GB", value: 200},
    {name: "200GB - 400GB", value: 400},
    {name: "Greater than 400GB", value: 500},
];

const deviceTypeOptions = [
    {name: "GAME and POS", value: "ALL"},
    {name: "GAME", value: "GAME"},
    {name: "POS", value: "POS"}
];


function StorageUsage() {
    const loading = useLoading();

    const [search, setSearch] = useState({
        text: '',
        params: {
            id: '',
            name: '',
            type: '',
        }
    });
    const [validSearch, setValidSearch] = useState(false)

    const [report, setReport] = useState("");
    const [range, setRange] = useState(rangeOptions[0].value);
    const [deviceType, setDeviceType] = useState(deviceTypeOptions[0].value);
    const [deviceVersionOptions, setDeviceVersions] = useState<ISelectOption[]>([{name: 'ALL', value: 'ALL'}])
    const [osVersionOptions, setOsVersions] = useState<ISelectOption[]>([{name: 'ALL', value: 'ALL'}])
    const [version, setVersion] = useState([]);
    const [os, setOS] = useState([]);

    useEffect(() => {
        setVersion(deviceVersionOptions[0].value)
        setOS(osVersionOptions[0].value)
        const res = loadData();
    }, [])

    const loadData = async () => {
        let res = await getStorageUsageVersions();

        if(res) {
            setDeviceVersions([...deviceVersionOptions, ...res['deviceVersions']])
            setOsVersions([...osVersionOptions, ...res['osVersions']])
        }
        return res;
    }

    const refreshReport = async (output: Output = Output.HTML) => {
        if(version === null || version.toString() === '') return notificationError('Please select a device version')
        if(os === null || os.toString() === '') return notificationError("Please select an OS version")
        loading.addLoading();

        const requestParams: Record<string, any> = {
            ...search.params,
            rangeOption: range,
            deviceType: deviceType,
            deviceVersion: version,
            osVersion: os,
            output
        };
        console.log(requestParams)


        const res = await getReport(
            removeEmpty(requestParams),
            endpoints.getStorageUsageReport,
            output,
        );
        if (output === Output.HTML) {
            setReport(res);
        }

        loading.removeLoading();
    };

    return (
        <DefaultFormParserLayout html={report}>

            <Space direction="horizontal" size="small" wrap>
                <SmartSearch
                    status='active'
                    value={search.text}
                    onChange={(e: string) => setSearch({ ...search, text: e })}
                    onValidSearch={setValidSearch}
                    label='Smart Search'
                    searchBy={['distributor']}
                    onObjValueChange={(e: any) => setSearch({ ...search, params: e })}
                    validOnEmpty
                    autoFocus
                />
                <SelectInput
                    label="Total Capacity"
                    options={rangeOptions}
                    value={range}
                    onSelectChange={(e) => setRange(e?.value ? e.value : e)}
                />
                <SelectInput
                    label="Device Type"
                    options={deviceTypeOptions}
                    value={deviceType}
                    onSelectChange={(e) => setDeviceType(e?.value ? e.value : e)}
                />
                <SelectInput
                    label="Application Version"
                    options={deviceVersionOptions}
                    value={version}
                    onSelectChange={(e) => setVersion(e?.value ? e.value : e)}
                />
                <SelectInput
                    label="OS Version"
                    options={osVersionOptions}
                    value={os}
                    onSelectChange={(e) => setOS(e?.value ? e.value : e)}
                />
                <Button
                    type="primary"
                    onClick={() => refreshReport()}
                    disabled={false}
                >
                    Refresh
                </Button>
            </Space>
        </DefaultFormParserLayout>
    );
}

export default StorageUsage;